import React, { useState } from "react";
import "./index.scss";

function CustomAlert({ isCopied, setIsCopied }) {
  return (
    <>
      {isCopied ? (
        <div className="toastify">
          <div className="toastify__toast">
            <div className="toastify__toast__text">Nusxa olindi !</div>
            <button
              className="toastify__close-button"
              onClick={() => setIsCopied(false)}></button>
          </div>
          <div className="toastify__progress"></div>
        </div>
      ) : null}
    </>
  );
}

export default CustomAlert;
